import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e24e515"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Vissza")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "party-image-shadow" }, null, -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Követés leállítása")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Térkép megnyitása")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_PartyDisplay = _resolveComponent("PartyDisplay")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_FatButton = _resolveComponent("FatButton")!
  const _component_FatButtonContainer = _resolveComponent("FatButtonContainer")!
  const _component_FatButtonFloat = _resolveComponent("FatButtonFloat")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createBlock(_component_ion_modal, {
    "is-open": _ctx.placeDetailsModal.open,
    "swipe-to-close": true,
    "show-backdrop": true,
    "presenting-element": _ctx.$root.$refs.mainRouterOutlet.$el,
    onDidDismiss: _ctx.dismiss
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.placeDetailsModal.placeDetails.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.dismiss }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { class: "party-container" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { class: "party-image-container" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_img, {
                        src: _ctx.placeDetailsModal.placeDetails.imageLocation,
                        class: "party-image"
                      }, null, 8, ["src"]),
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-justify-content-between" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "3fr" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { class: "ion-no-padding" }, {
                            default: _withCtx(() => [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.placeDetailsModal.placeDetails.name), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { class: "ion-no-padding" }, {
                            default: _withCtx(() => [
                              _createElementVNode("small", null, _toDisplayString(_ctx.placeDetailsModal.placeDetails.getLocation()), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { class: "ion-no-padding" }, {
                            default: _withCtx(() => [
                              _createElementVNode("small", null, _toDisplayString(_ctx.placeDetailsModal.placeDetails.age > 0
                                        ? _ctx.placeDetailsModal.placeDetails.age +
                                          "+"
                                        : ""), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "1fr",
                    class: "down"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { class: "ion-no-padding right" }, {
                            default: _withCtx(() => [
                              _createElementVNode("small", null, _toDisplayString(_ctx.placeDetailsModal.placeDetails.followers) + " követő", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { class: "ion-no-padding right" }, {
                            default: _withCtx(() => [
                              (_ctx.isFollowing)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_3, "Követed"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { class: "ion-no-padding right" }, {
                            default: _withCtx(() => [
                              (_ctx.isFollowing)
                                ? (_openBlock(), _createBlock(_component_ion_button, {
                                    key: 0,
                                    color: "primary",
                                    fill: "clear",
                                    size: "small",
                                    class: "ion-no-padding ion-no-margin"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_4
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { class: "ion-no-padding right" }, {
                            default: _withCtx(() => [
                              _createElementVNode("small", null, _toDisplayString(_ctx.placeDetailsModal.placeDetails.price ==
                                        0
                                            ? ""
                                            : _ctx.placeDetailsModal.placeDetails
                                                  .price + " Ft"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        fill: "outline",
                        size: "small",
                        onClick: _ctx.openMap
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.placeDetailsModal.placeDetails.description), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.placeDetailsModal.placeDetails.parties.length > 0
                                ? "Közeli események"
                                : "Még nincsenek események"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { class: "scrollfix" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_grid, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.placeDetailsModal.placeDetails
                                    .parties, (item) => {
                            return (_openBlock(), _createBlock(_component_PartyDisplay, {
                              details: item,
                              key: item.id
                            }, null, 8, ["details"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_FatButtonFloat, { pushup: true }, {
            default: _withCtx(() => [
              _createVNode(_component_FatButtonContainer, null, {
                default: _withCtx(() => [
                  _createVNode(_component_FatButton, {
                    icon: _ctx.globeOutline,
                    secondary: !_ctx.isFollowing,
                    text: _ctx.isFollowing ? 'Térkép' : null,
                    onClick: _ctx.openMap
                  }, null, 8, ["icon", "secondary", "text", "onClick"]),
                  (!_ctx.isFollowing)
                    ? (_openBlock(), _createBlock(_component_FatButton, {
                        key: 0,
                        icon: _ctx.checkmark,
                        text: "Követés"
                      }, null, 8, ["icon"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open", "presenting-element", "onDidDismiss"]))
}